import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type { GetBoardsDTO } from '@bb/domain/dist/types/dto/RetsController/getBoards';
import type { Country } from '@bb/domain/dist/types';

const getBoards = async (country?: Country) => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: '/rets/boards',
    ...(country && { params: { country } }),
  };

  const { data } = await axios.request<GetBoardsDTO>(config);

  return data;
};

export default getBoards;
